import { render, staticRenderFns } from "./viewBiker.vue?vue&type=template&id=d88e13e4&scoped=true&"
import script from "./viewBiker.vue?vue&type=script&lang=js&"
export * from "./viewBiker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88e13e4",
  null
  
)

export default component.exports